var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4759 11.7071C2.18016 11.8891 2 12.2115 2 12.5588V21C2 21.5523 2.44772 22 3 22H6V18.5C6 17.1193 7.11929 16 8.5 16C9.88071 16 11 17.1193 11 18.5V22H14C14.5523 22 15 21.5523 15 21V12.5588C15 12.2115 14.8198 11.8891 14.5241 11.7071L9.5482 8.64507C8.90538 8.24949 8.09462 8.24949 7.45181 8.64507L2.4759 11.7071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.89543 2 8 2.89543 8 4V6.88424C8.79664 6.76938 9.62408 6.9305 10.3343 7.36758L15.3102 10.4297C16.0496 10.8847 16.5 11.6907 16.5 12.5588V21C16.5 21.3556 16.4258 21.6938 16.292 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt6);
export default __webpack_public_path__ + "static/media/apartments-alt-6.84df9d9d9bf55fc847283955cc886043.svg";
export { ForwardRef as ReactComponent };